import React, { useState } from 'react'

const BeforeAfterGallery: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const beforeAfterPairs = [
    {
      id: 1,
      before: 'https://static.lumi.new/0a/0afa79ec13fe021d198c28b32af78f4b.png',
      after: 'https://static.lumi.new/df/dfe34f8f33457aca9b65d988ba8d11be.png',
      area: 'Bikini linija',
      treatments: 'samo 1 tretman'
    },
    {
      id: 2,
      before: 'https://static.lumi.new/37/37fc20e5f221f75702499129c8365a5b.png',
      after: 'https://static.lumi.new/c6/c6389eeea7145e3877317df915ab9f17.png',
      area: 'Cijele noge',
      treatments: '6 tretmana'
    },
    {
      id: 3,
      before: 'https://static.lumi.new/97/97612d168e46cff389663651a001945c.webp',
      after: 'https://static.lumi.new/9a/9a08c31c4671282ee8b7ff0e3441296c.png',
      area: 'Pazuha',
      treatments: '5 tretmana'
    }
  ]

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % beforeAfterPairs.length)
  }

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + beforeAfterPairs.length) % beforeAfterPairs.length)
  }

  const currentPair = beforeAfterPairs[currentIndex]

  return (
    <section className="py-16 md:py-20 animate-on-scroll" style={{ backgroundColor: 'var(--medispa-cloud)' }}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: 'var(--medispa-olive)' }}
          >
            Stvarni rezultati
          </h2>
          <p 
            className="text-lg md:text-xl max-w-2xl mx-auto"
            style={{ color: 'var(--medispa-text-grey)' }}
          >
            Uvjerite se u transformativne rezultate lasera DEKA Again
          </p>
        </div>

        <div className="relative">
          {/* Carousel Container */}
          <div className="bg-white rounded-lg overflow-hidden shadow-xl">
            <div className="grid grid-cols-2 gap-0">
              <div className="relative overflow-hidden">
                <img 
                  src={currentPair.before} 
                  alt={`${currentPair.area} prije tretmana`}
                  className="w-full h-80 md:h-96 object-cover"
                  loading="lazy"
                />
                <div 
                  className="absolute top-4 left-4 px-4 py-2 text-white text-xs md:text-sm font-semibold rounded-full shadow-lg"
                  style={{ backgroundColor: 'var(--medispa-moss)', zIndex: 20 }}
                >
                  Prije
                </div>
              </div>
              <div className="relative overflow-hidden">
                <img 
                  src={currentPair.after} 
                  alt={`${currentPair.area} nakon tretmana`}
                  className="w-full h-80 md:h-96 object-cover"
                  loading="lazy"
                />
                <div 
                  className="absolute top-4 left-4 px-4 py-2 text-white text-xs md:text-sm font-semibold rounded-full shadow-lg"
                  style={{ backgroundColor: 'var(--medispa-olive)', zIndex: 20 }}
                >
                  Poslije
                </div>
              </div>
            </div>
            
            <div className="p-6 text-center">
              <h3 
                className="text-2xl font-bold mb-2"
                style={{ color: 'var(--medispa-olive)' }}
              >
                {currentPair.area}
              </h3>
              <p 
                className="text-base"
                style={{ color: 'var(--medispa-text-grey)' }}
              >
                Rezultat nakon {currentPair.treatments}
              </p>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:scale-110 transition-transform z-30"
            style={{ color: 'var(--medispa-olive)' }}
            aria-label="Prethodna slika"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:scale-110 transition-transform z-30"
            style={{ color: 'var(--medispa-olive)' }}
            aria-label="Sljedeća slika"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {beforeAfterPairs.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentIndex ? 'w-8' : ''
                }`}
                style={{ 
                  backgroundColor: index === currentIndex 
                    ? 'var(--medispa-olive)' 
                    : 'var(--medispa-aloe)' 
                }}
                aria-label={`Idi na slajd ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <p 
            className="text-sm md:text-base italic"
            style={{ color: 'var(--medispa-text-grey)' }}
          >
            Rezultati mogu varirati. Individualni ishodi ovise o tipu dlačice, tonu kože, hormonalnim faktorima i pridržavanju plana tretmana.
          </p>
        </div>
      </div>
    </section>
  )
}

export default BeforeAfterGallery